export default __webpack_public_path__ + "static/media/JPG.c6d720c7.svg";